import { constants } from "redux/constants/redux-constants";

const initialState = {
   redirectPopup:false
  };

  const MobileTabReducer=(state = initialState, action)=>{
    switch (action?.type) {
        case constants?.MOBILETAB?.SET_REDIRECT_POPUP:
          return {
            ...state,
            redirectPopup: action?.payload,
          };
    
        default:
          return {
            ...state,
          };
      }
  }

  export default MobileTabReducer